import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'

import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTableModule, MatTableDataSource } from '@angular/material/table'

import { JsonPipe, NgClass, NgIf } from '@angular/common'

import { CnpjPipe } from '../../pipes/cpnj.pipes'
import { CpfPipe } from '../../pipes/cpf.pipes'
import { TelefonePipe } from '../../pipes/phone.pipes'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

interface modelLoading {
  contract: boolean
  email: boolean
  download: boolean
  edit: boolean
  manager: boolean
  view: boolean
  remove: boolean
  cancelContract: boolean
  active: boolean
  log: boolean
  excel: boolean
  convertClient: boolean
  convertSubClient: boolean
  convertToSupplier: boolean
  convertToClient: boolean
}

@Component({
  selector: 'table-list-simple',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    NgIf,
    CnpjPipe,
    CpfPipe,
    TelefonePipe,
    JsonPipe,
    MatProgressSpinner,
    NgClass,
  ],
  templateUrl: './table-list.component.html',
  styleUrl: './table-list.component.scss',
})
export class TableListComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() listClient = false
  @Input() columns: any[] = []
  @Input() spinLoad: modelLoading = {
    contract: false,
    email: false,
    download: false,
    edit: false,
    manager: false,
    view: false,
    remove: false,
    cancelContract: false,
    active: false,
    log: false,
    excel: false,
    convertClient: false,
    convertSubClient: false,
    convertToSupplier: false,
    convertToClient: false,
  }
  @Output() selectItem = new EventEmitter<any>()
  @Output() viewItem = new EventEmitter<any>()
  @Output() additionalOccurrenceItem = new EventEmitter<any>()
  @Output() downloadItem = new EventEmitter<any>()
  @Output() deleteItem = new EventEmitter<any>()
  @Output() managerItem = new EventEmitter<any>()
  @Output() sendContract = new EventEmitter<any>()
  @Output() sendEmail = new EventEmitter<any>()
  @Output() cancelContract = new EventEmitter<any>()
  @Output() activeItem = new EventEmitter<any>()
  @Output() logItem = new EventEmitter<any>()
  @Output() excelItem = new EventEmitter<any>()
  @Output() convertClientItem = new EventEmitter<any>()
  @Output() convertSubClientItem = new EventEmitter<any>()
  @Output() convertToSupplierItem = new EventEmitter<any>()
  @Output() convertToClientItem = new EventEmitter<any>()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges() {
    this.updateTableDataSource()
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  downloadItemEvent(item: any): void {
    this.downloadItem.emit(item)
  }

  viewItemEvent(item: any): void {
    this.viewItem.emit(item)
  }

  selectItemEvent(item: any): void {
    this.selectItem.emit(item)
  }

  deleteItemEvent(item: any): void {
    this.deleteItem.emit(item)
  }

  additionalOccurrenceEvent(item: any): void {
    this.additionalOccurrenceItem.emit(item)
  }

  sendContractEvent(item: any): void {
    this.sendContract.emit(item)
  }

  activeEvent(item: any): void {
    this.activeItem.emit(item)
  }

  sendEmailEvent(item: any): void {
    this.sendEmail.emit(item)
  }

  managerItemEvent(item: any): void {
    this.managerItem.emit(item)
  }

  logItemEvent(item: any): void {
    this.logItem.emit(item)
  }

  convertClientItemEvent(item: any): void {
    this.convertClientItem.emit(item)
  }

  convertSubClientItemEvent(item: any): void {
    this.convertSubClientItem.emit(item)
  }

  convertToSupplierItemEvent(item: any): void {
    this.convertToSupplierItem.emit(item)
  }

  convertToClientItemEvent(item: any): void {
    this.convertToClientItem.emit(item)
  }

  excelItemEvent(item: any): void {
    this.excelItem.emit(item)
  }

  cancelContractEvent(item: any): void {
    this.cancelContract.emit(item)
  }

  convertDateTimeString(date: string, hour = '') {
    if (hour != '') {
      const hourString = hour.split(':')
      return `${date} - ${hourString[0]}:${hourString[1]}`
    } else {
      return date
    }
  }

  getClass(status: number) {
    if (status == 1) {
      return 'status-sucess'
    } else if (status == 2) {
      return 'status-warning'
    } else {
      return 'status-danger'
    }
  }
}
